import {useGetPaymentsV1CMQuery} from "../../core/api/clockmaker-analytical-data-api";
import Loading from "../../components/Common/Loading";
import {DataGrid} from "@mui/x-data-grid";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";

import SearchIcon from '@mui/icons-material/Search';
import PurchaseCM from "../Analytics/cmPurchase";
import {useState} from "react";

const PaymentsCM = (props) => {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100
    })

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetPaymentsV1CMQuery({
        "userId": props.deviceId,
        "depth": props.depth,
        "page": paginationModel.page,
        "limit": paginationModel.pageSize
    }, {
        skip: !props.deviceId || props.deviceId.trim() === ""
    })


    const [showDetails, setShowDetails] = useState(false)
    const [selectedPayload, setSelectedPayload] = useState(0)

    const handleViewDetails = (data) => {
        setSelectedPayload(data)
        setShowDetails(true)
    }

    const columns = [
        {
          headerName: "ID",
          field: "userFk",
          width: 100
        },
        {
            field: 'action',
            headerName: 'Purchases',
            width: 70,
            renderCell: (params) => {
                // Assuming isAdmin is available in the component's scope
                return <IconButton
                    aria-label="edit"
                    onClick={() => handleViewDetails(params.row.payload)}
                >
                    <SearchIcon />
                </IconButton>
            },
            sortable: false,
            filterable: false,
        },
        {
            headerName: 'USD Price',
            field: 'price',
            width: 120,
            renderCell: (params) => {
                return params.value/100
            }
        },
        {
            headerName: 'Currency',
            field: 'currency',
            width: 100
        },
        {
            headerName: 'Usd Cents',
            field: 'usdCents',
            width: 120
        },
        {
            headerName: 'Purchase Network',
            field: 'purchaseNetwork',
            width: 120
        },
        {
            headerName: 'STransactionID',
            field: 'sTransactionId',
            width: 220
        },
        {
            headerName: 'Transaction ID',
            field: 'transactionId',
            width: 220
        },
        {
            headerName: 'Transaction Time',
            field: 'transactionTime',
            width: 200
        },
        {
            headerName: 'Store ID',
            field: 'storeId',
            width: 470
        },
        {
            headerName: 'Category',
            field: 'category',
            width: 150
        },
        {
            headerName: 'Item',
            field: 'item',
            width: 220
        },
        {
            headerName: 'Ruby',
            field: 'ruby',
            width: 150
        },
        {
            headerName: 'Value',
            field: 'value',
            width: 150
        },
        {
            label: 'payload',
            field: 'payload',
            width: 150
        },
        {
            headerName: 'Is test payment',
            field: 'sourceTable',
            width: 150,
            renderCell: (params) => {
                return params.value==='payments_test'?'TEST':''
            }
        },
    ]

    let payments = ""

    if (typeof data === "object") {

        payments = <Box sx={{width: '100%'}}>
            <DataGrid
                getRowId={(row) => row.transactionId}
                rows={data}
                rowCount={-1}
                columns={columns}
                pagination={true}
                paginationMode="server"
                pageSizeOptions={[100]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                autoHeight
                getRowClassName={(params) =>
                    params.row.sourceTable === 'payments_test' ? 'payments-test-row' : ''
                }
            />
        </Box>
    } else {
        payments = "no data"
    }

    return (
        <><Loading
            isLoading={isLoading||isFetching}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {payments}

        </Loading>

            {showDetails&&<Dialog
                maxWidth={"xl"}
                fullWidth={true}
                scroll={"paper"}
                open={showDetails} onClose={() => setShowDetails(false)}>
                <DialogTitle></DialogTitle>
                <DialogContent dividers={true}>
                    <PurchaseCM deviceId={props.deviceId} payload={selectedPayload}/>
                </DialogContent>
                <DialogActions>

                    <Button variant="outlined"
                            onClick={() => setShowDetails(false)}>
                        Close
                    </Button>

                </DialogActions>


            </Dialog>}
        </>
    )
}

export default PaymentsCM
